import { IApiPhotoRevealsResult } from 'affiny-core/modules/api/models/photoReveals';
import { paginatedRequest } from 'affiny-core/modules/helpers';
import { EAffinyEventOrigin } from '../affiny.eventorigins';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const PhotoRevealsResource = {
  getPhotoReveals: (accountId: string, pageNumber: number, pageSize: number) =>
    paginatedRequest<IApiPhotoRevealsResult>({
      apiEndPoint: AffinyEndpoint.PhotoReveals.url(`/${accountId}/`),
      pageNumber,
      pageSize,
    }),
  postPhotoReveal: (
    receiverId: string,
    messageId: string,
    isPhotoRequestAccepted: boolean
  ) =>
    AffinyEndpoint.PhotoReveals.url(`/${receiverId}/`)
      .headers({ 'X-Event-Origin': EAffinyEventOrigin.W_VIEW_R })
      .post({
        data: {
          type: 'postPhotoReveal',
          attributes: {
            is_revealed: isPhotoRequestAccepted,
            legacy_message_id: messageId,
          },
        },
      })
      .res(),
};
